import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';
import { fetchUserById } from '@Redux/actions';
import { store } from '@Redux/store';

class UserInfoService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.USER_INFO = '/api/userinfo';

        this.GET_BY_ID = '/{id}';
        this.GET_SIMPLE_BY_ID = '/simple/{id}';
        this.GET_BY_USERNAME = '/username/{username}';
        this.GET_BY_EMAIL = '/email/{email}';
        this.GET_BY_CONTACT_NUMBER = '/contact/{contact}';
        this.EXISTS_BY_CONTACT_NUMBER = '/exists/contact/{contact}';
        this.GET_LIST_BY_ORG = '/list/org/{orgId}';
        this.GET_COUNT_BY_ORG = '/count/org/{orgId}';
        this.GET_USER_INFO_BY_USER_ID_LIST = '/list/id';
        this.GET_MAP_BY_IDS = '/map/ids/{ids}';
        this.GET_USER_PHOTO_BY_ID = '/photo/{id}';
        this.SEARCH_LIST_BY_KEYWORD = '/search/keyword/{keyword}';
        this.SEARCH_LIST_BY_KEYWORD_IN_ORG = '/search/org/{orgId}/keyword/{keyword}';
        this.SEARCH_LIST_BY_USERNAME = '/search/username/{username}';
        this.SEARCH_USER_BY_FULLNAME = '/search/fullname/{fullName}';
        this.SEARCH_USER_BY_EMAIL = '/search/email/{email}';
        this.GET_FILTERED_LIST = '/filtered/list';
        this.REMOVE_PROFILE_PICTURE = '/remove/profile-picture';
        this.UPDATE_PROFILE_PICTURE = '/update/profile-picture';

        // redux users
        this.state = store.getState();
        this.users = this.state.user.users;
    }
    
    /**
     * This class manages the REST Protocols for User Information.
     *
     * GET Requests:
     *     - getUserById - GET By ID
     *     - getUserByUsername - GET By USERNAME
     *     - getUserByEmail - GET By EMAIL
     *     - getUserByContactNumber - GET By CONTACT NUMBER
     *     - userExistsByContactNumber - Exists By CONTACT NUMBER
     *     - searchUserByKeyword - GET SEARCH LIST By KEYWORD
     *     - searchUserByUsername - GET SEARCH LIST By USERNAME
     *     - searchUserByFullName - GET SEARCH LIST By FULL NAME
     *     - searchUserByEmail - GET SEARCH LIST By EMAIL
     *     - getUserListByIds - GET USER LIST By ID LIST
     *     - getUserListByOrgId - GET USER LIST By ORG ID
     *
     * POST Requests:
     *     - updateUserInfo - UPDATE User Info
     *
     * DELETE Requests:
     *     - deleteUserInfoById - DELETE User Info By ID
     */

    async getUserByIdFetch(id) {
        try {
            let url = window.location.origin + this.USER_INFO + this.GET_BY_ID;
            url = url
                .replace('{id}', id);
            const userRetData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userRetData;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserById(id) {
        if(!!id) {
            if(!!this.users) {
                if(!!this.users[id]) {
                    return this.users[id];
                } else {
                    return store.dispatch(fetchUserById(id));
                }
            } else {
                return store.dispatch(fetchUserById(id));
            }
        }
    }

    updateUserById(id, userObj) {
        let userCacheObj = localStorage.getItem('userCache');
        if(!!userCacheObj) {
            userCacheObj = JSON.parse(userCacheObj);
            userCacheObj[id] = userObj;
        } else {
            userCacheObj = {
                id: userObj
            };
        }
    }

    async getUserByIdRefetch(id) {
        let userCacheObj = localStorage.getItem('userCache');
        if(!!userCacheObj) {
            userCacheObj = JSON.parse(userCacheObj);
        } else {
            userCacheObj = {};
        }
        let userFetchObj = await this.getUserByIdFetch(id);
        if(!!userFetchObj?.body){
            let userRetObj = JSON.parse(userFetchObj.body);
            userCacheObj[id] = userRetObj;
            localStorage.setItem('userCache', JSON.stringify(userCacheObj));
        }
        return userFetchObj;
    }

    async getSimpleUserById(id) {
        try {
            let url = window.location.origin + this.USER_INFO + this.GET_SIMPLE_BY_ID;
            url = url
                .replace('{id}', id);
            const userRetData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userRetData;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserByUsername(username) {
        try {
            let url = window.location.origin + this.USER_INFO + this.GET_BY_USERNAME;
            url = url
                .replace('{username}', username);
            const userRetData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(response => response.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userRetData;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserByEmail(email) {
        if(email == null || email == '') return;
        try {
            let url = window.location.origin + this.USER_INFO + this.GET_BY_EMAIL;
            url = url
                .replace('{email}', email);
            const userRetData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(response => response.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userRetData;
        } catch(err) {
            console.log(err);
        }
    }

    async userExistsByContactNumber(contact) {
        try {
            let url = window.location.origin + this.USER_INFO + this.EXISTS_BY_CONTACT_NUMBER;
            url = url
                .replace('{contact}', contact);
            const userRetData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(response => response.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userRetData;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserByContactNumber(contact) {
        try {
            let url = window.location.origin + this.USER_INFO + this.GET_BY_CONTACT_NUMBER;
            url = url
                .replace('{contact}', contact);
            const userRetData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(response => response.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userRetData;
        } catch(err) {
            console.log(err);
        }
    }

    async searchUserByKeyword(keyword) {
        try {
            let url = window.location.origin + this.USER_INFO + this.SEARCH_LIST_BY_KEYWORD;
            url = url
                .replace('{keyword}', encodeURIComponent(keyword.trim()));
            const userList = this.fetch(url, {
                    method: 'GET'
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }

    async searchUserByKeywordInOrg(keyword, orgId) {
        try {
            let url = window.location.origin + this.USER_INFO + this.SEARCH_LIST_BY_KEYWORD_IN_ORG;
            url = url
                .replace('{keyword}', encodeURIComponent(keyword.trim()))
                .replace('{orgId}', orgId);
            const userList = this.fetch(url, {
                    method: 'GET'
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }

    async searchUserByUsername(username) {
        try {
            let url = window.location.origin + this.USER_INFO + this.SEARCH_LIST_BY_USERNAME;
            url = url
                .replace('{username}', username);
            const userList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }

    async searchUserByFullName(fullName) {
        try {
            let url = window.location.origin + this.USER_INFO + this.SEARCH_USER_BY_FULLNAME;
            url = url
                .replace('{fullName}', encodeURIComponent(fullName.trim()));
            const userList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }

    async searchUserByEmail(email) {
        try {
            let url = window.location.origin + this.USER_INFO + this.SEARCH_USER_BY_EMAIL;
            url = url
                .replace('{email}', email);
            const userList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserListByOrgId(orgId) {
        try {
            let url = window.location.origin + this.USER_INFO + this.GET_USER_INFO_BY_USER_ID_LIST;
            url = url
                .replace('{orgId}', orgId);
            const userList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserListByIds(idsList) {
        try {
            let url = window.location.origin + this.USER_INFO + this.GET_USER_INFO_BY_USER_ID_LIST;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const userList = this.fetch(url,{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(idsList)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }

    async getFilteredList(filter) {
        try {
            let url = window.location.origin + this.USER_INFO + this.GET_FILTERED_LIST;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const userList = this.fetch(url,{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(filter)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserMapFromIdListURL(ids) {
        try {
            let url = window.location.origin + this.USER_INFO + this.GET_MAP_BY_IDS;
            url = url
                .replace('{ids}', JSON.stringify(ids));
            const userList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserPhotoById(id) {
        try {
            let url = window.location.origin + this.USER_INFO + this.GET_USER_PHOTO_BY_ID;
            url = url
                .replace('{id}', JSON.stringify(id));
            const userList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserListByOrgId(orgId) {
        try {
            let url = window.location.origin + this.USER_INFO + this.GET_LIST_BY_ORG;
            url = url
                .replace('{orgId}', orgId);
            const userList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }

    async getUserCountByOrgId(orgId) {
        try {
            let url = window.location.origin + this.USER_INFO + this.GET_COUNT_BY_ORG;
            url = url
                .replace('{orgId}', orgId);
            const userList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userList;
        } catch(err) {
            console.log(err);
        }
    }

    async updateUserInfo(userData){
        try{
            let url = window.location.origin + this.USER_INFO;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            const userCreated = this.fetch(url,{
                method:'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(userData)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        } else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
            return userCreated;
        }
        catch(err){
            console.log(err);
        }
    }

    async removeProfilePicture(id) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.USER_INFO + this.REMOVE_PROFILE_PICTURE;
            let body = {
                id: id
            }
            const userInfoBody = this.fetch(url, {
                   method:'PUT',
                   headers: {
                       'Content-Type': 'application/json',
                       'X-XSRF-TOKEN': csrfToken
                   },
                   body: JSON.stringify(body)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userInfoBody;
        } catch(err) {
            console.log(err);
        }
    }

    async updateProfilePicture(id, photo) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.USER_INFO + this.UPDATE_PROFILE_PICTURE;
            let body = {
                id: id,
                photo: photo
            }
            const userInfoBody = this.fetch(url, {
                   method:'PUT',
                   headers: {
                       'Content-Type': 'application/json',
                       'X-XSRF-TOKEN': csrfToken
                   },
                   body: JSON.stringify(body)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return userInfoBody;
        } catch(err) {
            console.log(err);
        }
    }
}

export default UserInfoService;
